import axiosDefault from "./axiosDefault";

const API_URL = process.env.REACT_APP_API_URL;

export const createIVRHandler = (body) => {
  return axiosDefault.post(API_URL + "/ivr_tree", body);
};
export const updateIVRHandler = (id, body) => {
  return axiosDefault.put(API_URL + "/ivr_tree" + `/${id}`, body);
};
export const getSingleIVRHAndler = (id) => {
  return axiosDefault.get(API_URL + `/ivr_tree/single/${id}`);
};
export const deleteIVRHandler = (id) => {
  return axiosDefault.delete(API_URL + `/ivr_tree/${id}`);
};
export const getUserShortCodes = (userId) => {
  return axiosDefault.get(API_URL + `/ivr_tree/ivr_code/${userId}`);
};

export const approveIVR = (ivrId, action) => {
  return axiosDefault.put(
    API_URL + `/ivr_tree/approve/${ivrId}?action=${action}`
  );
};
export const closeIVR = (ivrId) => {
  return axiosDefault.put(API_URL + `/ivr_tree/close/${ivrId}`);
};

export const cloneIVR = (ivrId) => {
  return axiosDefault.put(API_URL + `/ivr_tree/clone/${ivrId}`);
};
export const getIVRsHandler = (userId, page, limit) => {
  const query = [];
  if (page !== undefined) {
    query.push(`page=${page}`);
  }
  if (limit !== undefined) {
    query.push(`limit=${limit}`);
  }

  return axiosDefault.get(API_URL + `/ivr_tree/${userId}?${query.join("&")}`);
};

export const getIvrDesigns = (page, limit) => {
  const query = [];
  if (page !== undefined) {
    query.push(`page=${page}`);
  }
  if (limit !== undefined) {
    query.push(`limit=${limit}`);
  }

  return axiosDefault.get(API_URL + `/ivr_tree?${query.join("&")}`);
};


export const getIvrDesignSmsNodes = (designId, page, limit) => {
  const query = [];
  if (page !== undefined) {
    query.push(`page=${page}`);
  }
  if (limit !== undefined) {
    query.push(`limit=${limit}`);
  }

  return axiosDefault.get(API_URL + `/ivr_tree/${designId}/sms-nodes?${query.join("&")}`);
};

export const getIvrDesignObdNodes = (designId, page, limit) => {
  const query = [];
  if (page !== undefined) {
    query.push(`page=${page}`);
  }
  if (limit !== undefined) {
    query.push(`limit=${limit}`);
  }

  return axiosDefault.get(API_URL + `/ivr_tree/${designId}/obd-nodes?${query.join("&")}`);
};

export const updateIvrDesignSmsNode = (id, message) => {
  const data = {
    id,
    message
  }
  return axiosDefault.patch(API_URL + `/ivr_tree/sms-nodes`, data);
};

export const updateIvrDesignObdNode = (id, file) => {

  const formData = new FormData()
  formData.append("audio", file)
  formData.append("id", id)
  return axiosDefault.patch(API_URL + `/ivr_tree/obd-nodes`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};




export const uploadAudio = (data) => {
  return axiosDefault.post(API_URL + `/ivr_tree/upload`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getUploadedAudios = (id, page, limit) => {
  const query = [];
  if (page !== undefined) {
    query.push(`page=${page}`);
  }
  if (limit !== undefined) {
    query.push(`limit=${limit}`);
  }
  return axiosDefault.get(
    API_URL + `/ivr_tree/${id}/upload?${query.join("&")}`
  );
};

export const deleteAudioUploaded = (id) => {
  return axiosDefault.delete(API_URL + `/ivr_tree/${id}/upload`);
};


export const getODBReportForAdmin = (params, userId) => {
  let query = [];
  if (params.startDate !== "") {
    query.push(`startDate=${params.startDate}`);
  }
  if (params.endDate !== "") {
    query.push(`endDate=${params.endDate}`);
  }
  return axiosDefault.get(API_URL + `/obd/admin/${userId}/report?${query.join("&")}`)
}

export const getOBDReport = (params) => {
  let query = [];
  if (params.startDate !== "") {
    query.push(`startDate=${params.startDate}`);
  }
  if (params.endDate !== "") {
    query.push(`endDate=${params.endDate}`);
  }
  return axiosDefault.get(API_URL + `/obd/report?${query.join("&")}`)
}


export const updateOBDOutgoingKey = (userId, data) => {
  return axiosDefault.patch(API_URL + `/obd/admin/${userId}/obd-key`, data);
};

export const deleteOBDOutgoingKey = (userId) => {
  return axiosDefault.delete(API_URL + `/obd/admin/${userId}/obd-key`);
};



